export const beforeItems = [
  "You search multiple resources to compare similar alopecia presentations.",
  "Your trichoscopy references are scattered across different files.",
  "You don’t always have a consistent structure for organizing initial findings.",
  "You want a clearer way to review scarring and non-scarring alopecias.",
  "Your differential diagnosis notes may lack a standardized format.",
  "You spend additional time organizing documentation.",
];

export const afterItems = [
  "Follow a five-stage initial assessment framework.",
  "Review twelve alopecia conditions through organized clinical references.",
  "Compare relevant trichoscopic findings using a visual atlas.",
  "Organize differential diagnosis considerations with structured flowcharts.",
  "Use practical assessment and documentation worksheets.",
  "Keep six specialized clinical volumes and five complementary resources together.",
];

export type Challenge = { title: string; body: string[]; solution: string };

export const challenges: Challenge[] = [
  {
    title: "Similar Hair Loss Patterns Can Be Difficult to Compare",
    body: [
      "Different alopecia conditions may share clinical characteristics.",
      "You want a structured way to review relevant differences.",
    ],
    solution: "Clinical comparison references covering twelve important alopecia conditions.",
  },
  {
    title: "You Want to Review Trichoscopy Findings More Systematically",
    body: [
      "Trichoscopic observations can provide important information, but their interpretation depends on clinical context.",
    ],
    solution: "Visual references organized around relevant hair and scalp findings.",
  },
  {
    title: "Your Differential Diagnosis References Are Scattered",
    body: ["You may need to compare several possible conditions when reviewing a presentation."],
    solution: "Educational differential diagnosis flowcharts and structured comparison worksheets.",
  },
  {
    title: "You Want a Clearer Approach to Scarring Alopecias",
    body: ["Certain inflammatory and cicatricial conditions require particular attention."],
    solution: "A dedicated educational atlas covering six important scarring alopecia conditions.",
  },
  {
    title: "You Need Practical Clinical Documentation Tools",
    body: [
      "Organizing patient history, observations, and follow-up information can involve multiple records.",
    ],
    solution: "Structured assessment templates and documentation checklists.",
  },
  {
    title: "You Want a Reference System You Can Revisit",
    body: [
      "Professional knowledge develops over time.",
      "You want your educational materials organized into a coherent framework.",
    ],
    solution: "Six specialized volumes supported by five complementary professional resources.",
  },
];
